// extracted by mini-css-extract-plugin
module.exports = {"PicSnippet":"Pictures_PicSnippet__17F4T","ComparisonGrid":"Pictures_ComparisonGrid__6hhF2","Comparison":"Pictures_Comparison__3BYno"};